import { Link } from '@tanstack/react-router';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-gray-200">404</h1>
          <div className="relative -mt-4">
            <h2 className="text-2xl font-semibold text-gray-800 mb-2">
              Page Not Found
            </h2>
            <p className="text-gray-600 mb-8">
              The page you're looking for doesn't exist or has been moved.
            </p>
          </div>
        </div>

        <div className="space-y-4">
          <Link
            to="/"
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200">
            Go Back Home
          </Link>

          <div>
            <button
              onClick={() => window.history.back()}
              className="text-blue-600 hover:text-blue-800 font-medium transition-colors duration-200">
              ← Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
